import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Icons } from 'src/app/models/icons.model';
import {
  UserSearchRequest,
  UserSearchResult,
} from 'src/app/models/user-search-request.model';
import { AdminService } from 'src/app/services/admin.service';

@Component({
  selector: 'app-admin-ad-search',
  standalone: false,
  templateUrl: './ad-search.component.html',
  styleUrls: ['./ad-search.component.scss'],
})
export class AdSearchComponent {
  requestModel = new UserSearchRequest();
  searchResults: UserSearchResult[];
  isReady: boolean = true;
  icons = new Icons();

  constructor(
    private adminService: AdminService,
    private modal: NgbActiveModal
  ) { }

  searchForUser() {
    this.isReady = false;
    this.adminService.searchForUser(this.requestModel).then((results) => {
      this.searchResults = results;
      this.isReady = true;
    });
  }

  selectUser(index: number) {
    const result = this.searchResults[index];
    this.modal.close(result);
  }

  closeModal() {
    this.modal.dismiss();
  }
}
